import { Button, Tooltip } from '@ksyos/design-system';
import type { EpisodeCategory, ServiceType } from '@common/enums';
import type { IEpisodeCategoryOneService, IServiceTypeWithOneService } from '@common/interfaces';
import type { UnavailableService } from '@common/interfaces/patientUnavailableServices';
import { translateKey } from '@frontend/translate';

interface INewProcessButtonRow {
    automation: string;
    data: IServiceTypeWithOneService | IEpisodeCategoryOneService;
    onClick: (name: any) => Promise<void>;
    previousSelection: ServiceType | EpisodeCategory | undefined;
    scrollToBottom?: () => void;
    translationKey: string;
    unavailableServices: UnavailableService[];
}

export function NewProcessButtonRow(props: INewProcessButtonRow) {
    const unavailableService = props.unavailableServices.find((item) => item.serviceId === props.data.oneTypeServiceId);

    return unavailableService ? (
        <Tooltip
            content={translateKey(
                `unavailableServices.${unavailableService.serviceCode.toLowerCase()}.${
                    unavailableService.reason
                }.alertAndTooltip`
            )}
            key={props.data.oneTypeServiceId}
            placement="bottom"
        >
            <Button
                iconRight="information"
                isDisabled={true}
                sx={{ '&:disabled': { cursor: 'not-allowed', pointerEvents: 'auto' } }}
                variant="outline"
            >
                {translateKey(`${props.translationKey}${props.data.name}`)}
            </Button>
        </Tooltip>
    ) : (
        <Button
            className={`automation-${props.automation}`}
            color="secondary"
            key={props.data.name}
            onClick={async () => {
                await props.onClick(props.data.name);
                if (props.scrollToBottom) {
                    props.scrollToBottom();
                }
            }}
            variant={props.data.name !== props.previousSelection ? 'outline' : 'solid'}
        >
            {translateKey(`${props.translationKey}${props.data.name}`)}
        </Button>
    );
}
